import ColumnFilter from './column-filter.vue'

ColumnFilter.install = Vue => Vue.component(ColumnFilter.name, ColumnFilter)

export default ColumnFilter
